import { computed, observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { Provider } from '@/features/iam/providers/Provider'
import { User } from '@/features/iam/users/User'
import { unixEpoch } from '@/utils/date-util'

export type WorkspaceApplicantStatus =
  | 'Applied'
  | 'Rejected'
  | 'Invited'
  | 'Accepted'
  | 'Withdrawn'
  | 'Expired'
  | 'Null'

export type WorkspaceApplicantProps = ModelProps<WorkspaceApplicant>

export class WorkspaceApplicant extends Model<WorkspaceApplicant> {
  @observable accessor user: User = User.none
  @observable accessor provider: Provider = Provider.none
  @observable accessor userPublicId = Id.none
  @observable accessor status: WorkspaceApplicantStatus = 'Applied'
  @observable accessor dateCreated: Date = unixEpoch()
  @observable accessor dateModified: Date = unixEpoch()
  @observable accessor dateInvited: Date | null = null

  /**
   * Returns the applicant's avatar, by provider if available, and by user if not.
   */
  @computed
  get avatar() {
    return this.provider.picture !== ''
      ? this.provider.avatar
      : this.user.avatar
  }

  /**
   * Returns the applicant's display name, by provider if available, and by user if not.
   */
  @computed
  get displayName() {
    return this.provider.familyName !== ''
      ? this.provider.displayName
      : this.user.displayName
  }
}
